import type { operations } from '@/types/schemas/api.JS-6223';
import { GET, setParams } from '../../_http';
type controller = operations['CustomerRetrieveDischargedPropertiesController_get'];

export type CustomerRetrieveDischargedPropertiesQuery = controller['parameters']['query'];
export type CustomerRetrieveDischargedPropertiesResponse =
  controller['responses']['200']['content']['application/json'];
export type DischargedPropertiesDto =
  controller['responses']['200']['content']['application/json']['dischargedProperties'];

export const retrieveDischargedProperties = GET(
  '/users/discharge-requests/retrieve-discharged-properties',
  setParams<CustomerRetrieveDischargedPropertiesQuery>,
)<CustomerRetrieveDischargedPropertiesResponse>;
